import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { issuerSelector } from '../../../../selectors';
import { useGetTheme } from '../../../../hooks/use-get-theme';

const useStockPrice = () => {
  const { latestStockPrice, companyTicker } = useSelector(issuerSelector);
  const theme = useGetTheme();

  return useMemo(
    () => ({
      theme,
      companyTicker,
      latestStockPrice,
    }),
    [theme, companyTicker, latestStockPrice],
  );
};

export default useStockPrice;
